export function downloadUrl(url: string, body: any, filename: string) {
    let accessToken = JSON.parse(localStorage.getItem('token'));
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Authorization', `${accessToken.token_type} ${accessToken.access_token}`);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onreadystatechange = function () {
        if (this.status === 404 || this.status === 500) {
            xhr.abort();
        }
    };
    if (detectIE()) {
        xhr.responseType = 'blob';
        xhr.onload = (x => {
            navigator.msSaveBlob(xhr.response, filename);
        });
        xhr.send(JSON.stringify(body));
    } else if (detectChrome()) {
        const a = document.createElement('a');
        let file;
        xhr.responseType = 'blob';
        xhr.onload = (x => {
            file = new Blob([xhr.response], { type: 'text/csv' });
            a.href = URL.createObjectURL(file);
            a.download = filename;
            a.click();
        });
        xhr.send(JSON.stringify(body));
    } else {
        const a = document.createElement('a');
        let file;
        xhr.responseType = 'blob';
        xhr.onload = (x => {
            file = new Blob([xhr.response], { type: 'text/csv' });
            a.href = URL.createObjectURL(file);
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        });
        xhr.send(JSON.stringify(body));
    }
}

export function detectIE() {
    const ua = window.navigator.userAgent;
    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        const rv = ua.indexOf('rv:');
        return true;
    }
    const edge = ua.indexOf('Edge/');
    if (edge > 0) {
        // Edge (IE 12+) => return version number
        return true;
    }
    // other browser
    return false;
}

export function detectChrome() {
    const ua = window.navigator.userAgent;
    if (/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)) {
        return true;
    } else {
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/utils/xhrDownloader.ts